export default __webpack_public_path__ + "static/media/diagram2.fe069b94.png";